import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ResultService {
    /**
     * Archive actionRequest by Id
     * @param resultId
     * @returns boolean
     * @throws ApiError
     */
    static resultDelete(resultId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/result/request/{resultId}',
            path: {
                'resultId': resultId,
            },
        });
    }
    /**
     * Request rewrite of a result
     * @param resultId
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    static resultRequestRewrite(resultId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/result/rewrite/{resultId}',
            path: {
                'resultId': resultId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Post feedback for a result
     * @param resultId
     * @param requestBody
     * @returns boolean
     * @throws ApiError
     */
    static resultSendFeedback(resultId, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/result/feedback/{resultId}',
            path: {
                'resultId': resultId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Edit result
     * @param resultId
     * @param requestBody
     * @returns ActionResultBoInterface
     * @throws ApiError
     */
    static resultEdit(resultId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/result/edit/{resultId}',
            path: {
                'resultId': resultId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
